<template>
  <!-- 订单列表组件 -->
  <section class="list-wrap">
    <el-table :data="tableData" class="goodsList" :header-cell-style="{ background: '#f8f8f8' }">
      <el-table-column prop="applymentId" label="申请单编号" min-width="100"> </el-table-column>
      <el-table-column prop="businessLicenseInfoMerchantName" label="商户名称"> </el-table-column>
      <el-table-column prop="subMchid" label="商户号"> </el-table-column>
      <el-table-column prop="merchantType" label="服务商主体"> </el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          {{ statusType(scope.row.status) }}
        </template>
      </el-table-column>
      <el-table-column prop="contactName" label="创建员工"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="100" align="center">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.status == 0"
            @click.native="
              handleEdit(scope.row.uuid, scope.row.subjectType, scope.row.merchantType, scope.row.merchantId)
            "
            type="text"
            size="small"
          >
            继续填写
          </el-button>
          <el-button
            v-if="scope.row.status == 4 || scope.row.status == 5"
            @click.native="handleDetails(scope.row)"
            type="text"
            size="small"
          >
            查看申请
          </el-button>
          <el-button
            v-if="scope.row.status == 1 || scope.row.status == 2 || scope.row.status == 3 || scope.row.status == 6"
            @click.native="handleProgress(scope.row)"
            type="text"
            size="small"
          >
            查看进度
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </section>
</template>
<script>
export default {
  components: {},
  props: {
    applyList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      // tableHeight: document.documentElement.clientHeight - 485,
    };
  },
  computed: {
    tableData() {
      return this.applyList;
    },
  },
  methods: {
    handleEdit(uuid, subjectType, merchantType, merchantId) {
      let id = undefined;
      if (subjectType === 'SUBJECT_TYPE_INDIVIDUAL') {
        id = 0;
      } else if (subjectType === 'SUBJECT_TYPE_ENTERPRISE') {
        id = 1;
      } else if (subjectType === 'SUBJECT_TYPE_INSTITUTIONS') {
        id = 2;
      } else if (subjectType === 'SUBJECT_TYPE_OTHERS') {
        id = 3;
      }
      this.$router.push({
        path: '/merchants/addMerchants',
        query: {
          type: 'edit',
          uuid,
          id,
          subjectName: subjectType,
          facilitatorName: merchantType,
          merchantId,
        },
      });
    },
    //状态
    statusType(orderStatus) {
      if (orderStatus == 0) {
        return '待提交';
      }
      if (orderStatus == 1) {
        return '待审核';
      }
      if (orderStatus == 2) {
        return '待验证';
      }
      if (orderStatus == 3) {
        return '待签约';
      }
      if (orderStatus == 4) {
        return '已驳回';
      }
      if (orderStatus == 5) {
        return '已完成';
      }
      if (orderStatus == 6) {
        return '开通权限中';
      }
    },
    handleDetails(row) {
      this.$router.push({
        path: '/merchants/viewDetails',
        query: {
          uuid: row.uuid,
        },
      });
    },
    handleProgress(row) {
      this.$router.push({
        path: '/merchants/viewProgress',
        query: {
          uuid: row.uuid,
          merchantId: row.merchantId,
          name: row.businessLicenseInfoMerchantName,
          createTime: row.createTime,
        },
      });
    },
  },
};
</script>

<style scoped lang="less">
</style>
